









import { State, Getter, Action } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
  },
})
export default class PageError extends Vue {
  @Action('user/me') getAuth!: (dontUseStorage: boolean) => Promise<Auth>;

  mounted() {
    // @ts-ignore
    if (this.$route.params.code === '401') {
      this.getAuth(true).catch((res: ErrorResponse) => {
        if (res.status === 401) {
          this.$router.push({ name: 'logout' });
        }
      });
    }
  }
}
